export enum Experiment {
  UseNotificationsV2Api = 'specs.ping.membersAreaUseNotificationsV2Api',
  HideNotificationsCounterInDropdownAndMemberMenus = 'specs.ping.membersArea.hideNotificationsCounterInDropdownAndMemberMenus',
  AddNavigationIntentParams = 'specs.membersArea.addNavigationIntentParams',
  AddStandalonePagesRoutesToPublicAppData = 'specs.membersArea.addStandalonePageRoutesToPublicAppData',
  AddV1ContextCheck = 'specs.membersArea.addV1ContextCheck',
}
